
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface JobExperienceFieldProps {
  job: Pick<Job, 'experience_required'>;
  isEditing: boolean;
  formDataExperience: string | number;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const JobExperienceField: React.FC<JobExperienceFieldProps> = ({ job, isEditing, formDataExperience, onInputChange }) => {
  return (
    <div>
      <Label htmlFor="experience_required" className="text-xs font-medium text-muted-foreground">Experience Required (Years)</Label>
      {isEditing ? (
        <Input
          id="experience_required"
          name="experience_required"
          type="number"
          value={formDataExperience}
          onChange={onInputChange}
          placeholder="e.g. 5"
          className="text-sm"
          min="0"
        />
      ) : (
        <p>{job.experience_required ?? 'N/A'}</p>
      )}
    </div>
  );
};
